import { APIModel } from '@shared/interfaces';

import { PlatformCapability } from '@/connections/models/platform-capability.enum';
import { PlatformAuthMethod } from '@/connections/models/platform-auth-method.enum';

export class Platform implements APIModel {
    id: number = -1;
    name?: string;
    avatar?: string;
    capabilities = [] as PlatformCapability[];
    authMethod = '' as PlatformAuthMethod;
    type: string = '';

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.name = data.name ?? undefined;
        this.avatar = data.avatar ?? undefined;
        this.capabilities = data.capabilities ?? [];
        this.authMethod = data.auth_method ?? undefined;
        this.type = data.type ?? '';
        return this;
    }

    serialize(): any {
        return {
            id: this.id,
            name: this.name,
            avatar: this.avatar,
            capabilities: this.capabilities,
            auth_method: this.authMethod,
            type: this.type,
        };
    }

    static Sort(p1: Platform, p2: Platform): number {
        const localeCompare = p1.name?.localeCompare(p2.name ?? '') ?? 0;
        return localeCompare === 0 ? p1.id - p2.id : localeCompare;
    }
}
